/** Where a signed-in person lands when no particular destination was asked for. */

export function isApprovedMentorParent(user) {
  return user?.role === 'parent' && user?.mentor_approval_status === 'approved';
}

export function landingPath(user) {
  if (user?.role === 'admin') return '/admin';
  if (user?.role === 'coordinator') return '/coordinator';
  if (user?.role === 'partner') return '/partner';
  // An approved mentor-parent opens in the mentor workspace, where other people
  // are waiting on them. The Parent/Mentor switch stays one tap away.
  if (user?.role === 'parent') return isApprovedMentorParent(user) ? '/mentor' : '/parent';
  return '/';
}
